import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Gamepad2, Gift, Settings, Monitor, Smartphone } from 'lucide-react';

const Home = () => {
  return (
    <div className="min-h-screen relative" data-testid="home-screen">
      <div className="wave-background" />
      
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-16">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-7xl font-bold text-white font-['Outfit'] mb-4">
            Event Experience
          </h1>
          <p className="text-xl text-slate-400">
            Demo System — Energy Tree, Quiz Game, Raffle
          </p>
        </div>

        {/* Modules */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {/* Energy Tree */}
          <div className="operator-card p-8" data-testid="tree-module">
            <div className="w-16 h-16 rounded-2xl bg-blue-500/20 flex items-center justify-center mb-6">
              <Zap size={32} className="text-blue-400" />
            </div>
            <h2 className="text-2xl font-bold text-white font-['Outfit'] mb-3">
              Energy Tree
            </h2>
            <p className="text-slate-400 mb-6">
              320 participants contribute energy to the central P&G logo with Tesla moment effect.
            </p>
            <div className="space-y-3">
              <Link 
                to="/tree" 
                className="nav-link w-full justify-center"
                data-testid="tree-screen-link"
              >
                <Monitor size={18} />
                Big Screen
              </Link>
              <Link 
                to="/operator/tree" 
                className="nav-link w-full justify-center"
                data-testid="tree-operator-link"
              >
                <Settings size={18} />
                Operator Panel
              </Link>
            </div>
          </div>

          {/* Quiz Game */}
          <div className="operator-card p-8" data-testid="game-module">
            <div className="w-16 h-16 rounded-2xl bg-green-500/20 flex items-center justify-center mb-6">
              <Gamepad2 size={32} className="text-green-400" />
            </div>
            <h2 className="text-2xl font-bold text-white font-['Outfit'] mb-3">
              Quiz Game
            </h2>
            <p className="text-slate-400 mb-6">
              Interactive video quiz with pause, multiple choice, and elimination mechanics.
            </p>
            <div className="space-y-3">
              <Link 
                to="/game/lobby" 
                className="nav-link w-full justify-center"
                data-testid="game-lobby-link"
              >
                <Monitor size={18} />
                Lobby Screen
              </Link>
              <Link 
                to="/game/screen" 
                className="nav-link w-full justify-center"
                data-testid="game-screen-link"
              >
                <Monitor size={18} />
                Game Screen
              </Link>
              <Link 
                to="/p/game" 
                className="nav-link w-full justify-center"
                data-testid="mobile-join-link"
              >
                <Smartphone size={18} />
                Join as Player
              </Link>
              <Link 
                to="/operator/game" 
                className="nav-link w-full justify-center"
                data-testid="game-operator-link"
              >
                <Settings size={18} />
                Operator Panel
              </Link>
            </div>
          </div>

          {/* Raffle */}
          <div className="operator-card p-8" data-testid="raffle-module">
            <div className="w-16 h-16 rounded-2xl bg-yellow-500/20 flex items-center justify-center mb-6">
              <Gift size={32} className="text-yellow-400" />
            </div>
            <h2 className="text-2xl font-bold text-white font-['Outfit'] mb-3">
              Raffle Draw
            </h2>
            <p className="text-slate-400 mb-6">
              Slot-machine style raffle with 10-second animation and celebration effects.
            </p>
            <div className="space-y-3">
              <Link 
                to="/raffle/screen" 
                className="nav-link w-full justify-center"
                data-testid="raffle-screen-link"
              >
                <Monitor size={18} />
                Big Screen
              </Link>
              <Link 
                to="/operator/raffle" 
                className="nav-link w-full justify-center"
                data-testid="raffle-operator-link"
              >
                <Settings size={18} />
                Operator Panel
              </Link>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-slate-500 text-sm">
          <p>Demo Mode — No database, no authentication required</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
